import { onMounted, onUnmounted } from 'vue';

/**
 * Infinite scroll composable for Vue 3.
 * @param {Function} fetchNextPage - Callback to fetch the next page of data.
 * @param {() => boolean} hasNextPage - Function returning whether more data is available.
 * @param {() => boolean} isFetching - Function returning whether a fetch is in progress.
 * @returns {{ check: Function }} re-runs the near-bottom check
 */
export default function useInfiniteScroll(fetchNextPage, hasNextPage, isFetching) {
  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const viewportHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;
    if (
      scrollY + viewportHeight >= fullHeight - 200
      && hasNextPage()
      && !isFetching()
    ) {
      fetchNextPage();
    }
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  // Call after content changes: if the page is too short to scroll, nothing else would load more
  return { check: handleScroll };
}
